import { combineReducers, Reducer } from 'redux';

import { isActionOfType } from '../../../../utils/action.utils';

import * as types from './sessions.types';
import * as constants from './sessions.constants';

const initialState: types.ISessionsPageState = {
  sessionIds: [],
  nextSessionId: null,
  lastSessionId: null,
  notAttendedIds: [],
};

const sessionIdsReducer: Reducer<
  types.ISessionsPageState['sessionIds'],
  types.IStoreFetchedSessions | types.IClearFetchedSessions
> = (state = initialState.sessionIds, action) => {
  if (isActionOfType<types.IStoreFetchedSessions>(action, constants.STORE_SESSION_IDS)) {
    return action.payload;
  } else if (isActionOfType<types.IClearFetchedSessions>(action, constants.CLEAR_SESSION_IDS)) {
    return initialState.sessionIds;
  }
  return state;
};

const nextSessionIdReducer: Reducer<
  types.ISessionsPageState['nextSessionId'],
  types.IStoreNextSession | types.IClearNextSession
> = (state = initialState.nextSessionId, action) => {
  if (isActionOfType<types.IStoreNextSession>(action, constants.STORE_NEXT_SESSION)) {
    return action.payload;
  } else if (isActionOfType<types.IClearNextSession>(action, constants.CLEAR_NEXT_SESSION)) {
    return initialState.nextSessionId;
  }
  return state;
};

const lastSessionIdReducer: Reducer<
  types.ISessionsPageState['lastSessionId'],
  types.IStoreLastSession | types.IClearLastSession
> = (state = initialState.lastSessionId, action) => {
  if (isActionOfType<types.IStoreLastSession>(action, constants.STORE_LAST_SESSION)) {
    return action.payload;
  } else if (isActionOfType<types.IClearLastSession>(action, constants.CLEAR_LAST_SESSION)) {
    return initialState.lastSessionId;
  }
  return state;
};

const notAttendedReducer: Reducer<
  types.ISessionsPageState['notAttendedIds'],
  types.IStoreNotAttended | types.IClearNotAttended
> = (state = initialState.notAttendedIds, action) => {
  if (isActionOfType<types.IStoreNotAttended>(action, constants.STORE_NOT_ATTENDED)) {
    return action.payload;
  } else if (isActionOfType<types.IClearNotAttended>(action, constants.CLEAR_NOT_ATTENDED)) {
    return initialState.notAttendedIds;
  }
  return state;
};

export const sessionsPageReducer: Reducer<types.ISessionsPageState, types.ISessionsPageAction> = combineReducers({
  sessionIds: sessionIdsReducer,
  nextSessionId: nextSessionIdReducer,
  lastSessionId: lastSessionIdReducer,
  notAttendedIds: notAttendedReducer,
});
